import React from 'react';
import './ProgressIndicator.css';

const ProgressIndicator = ({ currentStep = 1, steps = [] }) => {
  return (
    <div className="progress-indicator">
      <div className="progress-indicator__container">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;
          
          return (
            <React.Fragment key={stepNumber}>
              <div className={`progress-indicator__step ${isActive ? 'progress-indicator__step--active' : ''} ${isCompleted ? 'progress-indicator__step--completed' : ''}`}>
                <div className="progress-indicator__circle">
                  {isCompleted ? (
                    <svg className="progress-indicator__checkmark" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <span className="progress-indicator__number">{stepNumber}</span>
                  )}
                </div>
                <span className="progress-indicator__label">{step}</span>
              </div>
              {index < steps.length - 1 && (
                <div className="progress-indicator__connector"></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;
